type VectorGlyph = { path: string; size: number }

// Square vector viewboxes shared by stamp layout and rendering. These symbols
// are paths, not characters to measure in the annotation's text font.
export const STAMP_GLYPHS: Readonly<Record<string, VectorGlyph | undefined>> = {
  '✓': {
    path: 'M10.5 3.25L4.5 9.25L1.75 6.5L2.75 5.5L4.5 7.25L9.5 2.25L10.5 3.25Z',
    size: 12
  }
}
